@if (showNavigation) {
<lib-navigation-header
[routesAndNames]="userService.routesAndNames">

</lib-navigation-header>
}
<div class="main">
  <div>
    <router-outlet></router-outlet>
  </div>
</div>
